export default async (context, lang) => {
  return await fetch(`${  context.$config.CONTENT_API }/api/content/translations?lang=${ lang }&bookmaker=${ process.env.BOOKMAKER }`, {}).then((res) => res.json());
}